// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createAdminVendorTypeChangeRequests = (client) => ({
    /**
     * `POST /admin/vendor-type-change-requests/:id/approve`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminVendorTypeChangeRequestsIdApproveCreate
     * @source apps/backend/src/api/admin/vendor-type-change-requests/[id]/approve/route.ts
     */
    approve: (id, body, query, headers) => client.fetch(buildPath("/admin/vendor-type-change-requests/:id/approve", [id]), { method: "POST", body, query, headers }),
    /**
     * `GET /admin/vendor-type-change-requests`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminVendorTypeChangeRequestsList
     * @source apps/backend/src/api/admin/vendor-type-change-requests/route.ts
     */
    list: (query, headers) => client.fetch("/admin/vendor-type-change-requests", { method: "GET", query, headers }),
    /**
     * `POST /admin/vendor-type-change-requests/:id/reject`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminVendorTypeChangeRequestsIdRejectCreate
     * @source apps/backend/src/api/admin/vendor-type-change-requests/[id]/reject/route.ts
     */
    reject: (id, body, query, headers) => client.fetch(buildPath("/admin/vendor-type-change-requests/:id/reject", [id]), { method: "POST", body, query, headers }),
});
//# sourceMappingURL=vendor-type-change-requests.js.map